export interface ICommand { }

export class CreateProjectPhaseDefinitionCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.CreateProjectPhaseDefinitionCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	ProjectPhaseDefinitionId: string
	Name: string
	PrevPhaseId: string

	constructor (workspaceId: number, id: string, projectPhaseDefinitionId: string, name: string, prevPhaseId: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.ProjectPhaseDefinitionId = projectPhaseDefinitionId
		this.Name = name
		this.PrevPhaseId = prevPhaseId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.CreateProjectPhaseDefinitionCommandV1, TCh.Domain.Quest'
	}

}

export class CreateStrategyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.CreateStrategyCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Name: string
	Description: string

	constructor (workspaceId: number, id: string, name: string, description: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Name = name
		this.Description = description
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.CreateStrategyCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteProjectPhaseDefinitionCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.DeleteProjectPhaseDefinitionCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	ProjectPhaseDefinitionId: string

	constructor (workspaceId: number, id: string, projectPhaseDefinitionId: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.ProjectPhaseDefinitionId = projectPhaseDefinitionId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.DeleteProjectPhaseDefinitionCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteStrategyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.DeleteStrategyCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string

	constructor (workspaceId: number, id: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.DeleteStrategyCommandV1, TCh.Domain.Quest'
	}

}

export class RenameProjectPhaseDefinitionCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.RenameProjectPhaseDefinitionCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	ProjectPhaseDefinitionId: string
	Name: string

	constructor (workspaceId: number, id: string, projectPhaseDefinitionId: string, name: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.ProjectPhaseDefinitionId = projectPhaseDefinitionId
		this.Name = name
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.RenameProjectPhaseDefinitionCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewAllProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewFinishedProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewProposedProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewScheduledProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class SaveViewStartedProjectsPageCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Grid: string

	constructor (workspaceId: number, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest'
	}

}

export class TriggerMetricUpdatesCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.TriggerMetricUpdatesCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string

	constructor (workspaceId: number, id: string)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.TriggerMetricUpdatesCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateResourceUnitCostsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.UpdateResourceUnitCostsCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	FromYear: number
	Entries: any

	constructor (workspaceId: number, id: string, fromYear: number, entries: any)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.FromYear = fromYear
		this.Entries = entries
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.UpdateResourceUnitCostsCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateStrategySettingsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.UpdateStrategySettingsCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	Id: string
	Name: string
	Description: string
	Currency: string
	DefaultPnlId: string
	IncludeCogs: boolean
	IncludeOpex: boolean
	IncludeOther: boolean
	FiscalYearStartMonth: number

	constructor (workspaceId: number, id: string, name: string, description: string, currency: string, defaultPnlId: string, includeCogs: boolean, includeOpex: boolean, includeOther: boolean, fiscalYearStartMonth: number)
	{
		this.WorkspaceId = workspaceId
		this.Id = id
		this.Name = name
		this.Description = description
		this.Currency = currency
		this.DefaultPnlId = defaultPnlId
		this.IncludeCogs = includeCogs
		this.IncludeOpex = includeOpex
		this.IncludeOther = includeOther
		this.FiscalYearStartMonth = fiscalYearStartMonth
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.UpdateStrategySettingsCommandV1, TCh.Domain.Quest'
	}

}

